import PageRootNav from '../components/PageRootNav/PageRootNav';
import AuditGrid from '../modules/auditTrails/AuditGrid';

const AuditTrails = () => {
    return (
        <>
            <PageRootNav label="Audit trails" />
            <AuditGrid />
        </>
    );
};

export default AuditTrails;
